import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/estoqueAreia/actions';

import Form from './form';

function PitStopEstoqueAreia() {
  const redux = useSelector((state) => state.estoqueAreia);

  const statusSilo = useMemo(
    () => [
      { label: 'S', value: t('s.geral.opcoes.sim') },
      { label: 'N', value: t('s.geral.opcoes.nao') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.configuracao.terminal.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'descricaotipoareia',
        label: t('s.cadastro.pitstop.tipoareia'),
        filter: { type: 'text' },
      },
      {
        id: 'nomepostotipoareia',
        label: t('s.configuracao.posto.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'capacidadepostotipoareia',
        label: t('s.relatorio.afericao.volume'),
        formatted: (value) => {
            if (
              Number(value) === 0
            ) {
              return '';
            }
            return String(value);
          },
        filter: { type: 'number' },
      },
    ],
    [statusSilo]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idpostotipoareia"
      detach="codigonomeposto"
    />
  );
}

export default PitStopEstoqueAreia;